// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"a849fdd3","23":"d006f2a6","41":"80e736e3","45":"73c5fd5c","741":"d9ae6967","744":"95612515","855":"2f00fb0e","861":"130484a0","970":"3f8a0da5"}[chunkId] + ".chunk.js";
};